
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { PageHeader } from './layout/site';
import Paper from "@mui/material/Paper";
import Skaiciuokle from "../skaiciuokle/Skaiciuokle";
import FooterComponent from "./layout/FooterComponent";
import MokesciuAprasymasComponent from './MokesciuAprasymasComponent';
import SkaiciuoklesAprasymasComponent from './SkaiciuoklesAprasymasComponent';
import SkaiciuoklesTurinys from "./SkaiciuoklesTurinys";

type Props = {
  initialYear?: string;
}

function SkaiciuoklesPuslapisComponent({ initialYear }: Props) {
  const [year, setYear] = useState(initialYear ?? new Date().getFullYear().toString());

  const onYearChange = (year: string) => {
    setYear(year);
  };

  return (
    <div itemScope itemType="https://schema.org/WebApplication">
      <link
        itemProp="applicationCategory"
        href="https://schema.org/FinanceApplication"
      />

      <PageHeader title={`Atlyginimo skaičiuoklė ${year} metams`} />

      <Box
        my={{ xs: 2, md: 5 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 2, md: 4 },
          maxWidth: 'md',
          width: '100%',
          margin: 'auto',
        }}
      >
        <Skaiciuokle initialYear={initialYear} onYearChange={onYearChange}>
          <SkaiciuoklesTurinys />
        </Skaiciuokle>

        <Paper sx={{ p: { xs: 2, md: 4 } }} elevation={3}>
          <SkaiciuoklesAprasymasComponent />
        </Paper>

        <Paper sx={{ p: { xs: 2, md: 4 } }} elevation={3}>
          <MokesciuAprasymasComponent />
        </Paper>
      </Box>

      <FooterComponent />
    </div>
  );
}

export default SkaiciuoklesPuslapisComponent;
